import {
  makeStyles,
  Typography,
  type TypographyProps,
} from "@material-ui/core";
import classnames from "classnames";
import React from "react";

const useStyles = makeStyles({
  root: {
    whiteSpace: "pre-line",
  },
});

interface MultiLineTypographyProps extends TypographyProps {
  component?: React.ElementType;
}

export const MultiLineTypography = ({
  className,
  ...props
}: MultiLineTypographyProps) => {
  const classes = useStyles();

  return (
    <Typography className={classnames(classes.root, className)} {...props} />
  );
};
